module.exports = __webpack_public_path__ + "media/src/fonts/roboto-mono/roboto-mono-300-light-italic-1189bf6a1da86b59b7803a2cfb460dd9.woff";